@layer module {
} // layer module










@layer app {
.table-customize-title {
            margin-bottom: $size-20;
    }

.table-customize-title {
            color: var(--table-customize-title);
            font-size: var(--font-size-xl);
            font-style: normal;
            font-weight: 400;
            line-height: $size-28;
    }
} // layer app
